import Service, { service } from '@ember/service';
import { task } from 'ember-concurrency';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type MetricsService from 'garaje/services/metrics';
import type StateService from 'garaje/services/state';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import urlBuilder from 'garaje/utils/url-builder';

export default class DoceboService extends Service {
  @service declare state: StateService;
  @service declare ajaxFetch: AjaxFetchService;
  @service declare metrics: MetricsService;

  getDoceboUrlTask = task({ drop: true }, async () => {
    const URL = urlBuilder.growth.getDoceboSsoUrl();
    const settings = {
      URL,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        data: {
          attributes: {
            'first-name': this.state.currentUser.firstName,
            'last-name': this.state.currentUser.lastName,
            company: this.state.currentCompany.name,
            timezone: this.state.currentLocation?.timezone,
            locale: this.state.currentLocation?.locale,
          },
        },
      }),
    };

    try {
      const { url } = await this.ajaxFetch.request<{ url: string }>(URL, settings);
      return url;
    } catch (e) {
      const error_message = parseErrorForDisplay(e);
      this.metrics.trackEvent('POST Docebo Sign In failed', {
        type: 'error',
        message_title: error_message,
        location_id: this.state.currentLocation?.id,
        company_id: this.state.currentCompany?.id,
      });
      return;
    }
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    docebo: DoceboService;
  }
}
